module.exports = __webpack_public_path__ + "img/13.643e1bdd.png";